import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";

import {
  snackbarSummarySuccessEditProject,
  snackbarSummarySuccessEditProjectSubTitle,
} from "_constants";
import { setNameProject } from "store/slicer/GestioneDetailProjectSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { ActionsProject } from "./ActionsProject";
import { Project } from "interfaces";
import { useEffect, useState } from "react";
import { editProject } from "services";
import { useSnackbar } from "providers/SnackbarProvider";
import { getUserId } from "utils";
import { VisibilityChip } from "components/shared";

export const HeaderDetailProject = ({
  project,
  projectId,
}: {
  project: Project;
  projectId: string;
}) => {
  const dispatch = useAppDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(project?.name);
  const { showSnackbar } = useSnackbar();
  const headerName = useAppSelector(
    (state) => state.gestioneDetailProjectSlice.header.name
  );
  const currentProject = useAppSelector(
    (state) => state.gestioneProjectsSlice.currentProject
  );

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleEditClick = () => {
    setIsEditing(true);
  };

  useEffect(() => {
    if (project) {
      setInputValue(project.name);
      dispatch(setNameProject(project.name));
    }
  }, [dispatch, project]);

  const handleBlurOrEnter = () => {
    if (inputValue !== headerName && inputValue) {
      editProject({ id: projectId, name: inputValue })
        .then((_) => {
          showSnackbar({
            severity: "success",
            summary: snackbarSummarySuccessEditProject,
            detail: snackbarSummarySuccessEditProjectSubTitle,
            life: 5000,
          });

          dispatch(setNameProject(inputValue));
          setIsEditing(false);
        })
        .catch((_) => {
          setInputValue(headerName);
          setIsEditing(false);
        });
    } else {
      setInputValue(headerName);
      setIsEditing(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleBlurOrEnter();
    }
  };

  return project && projectId ? (
    <div className="main-content-header flex-container align-center justify-between padd-18 border-bottom">
      <div className="container-title">
        {isEditing ? (
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            onBlur={handleBlurOrEnter}
            onKeyDown={handleKeyDown}
            autoFocus
            className="rename-project-input margin-right-8"
            maxLength={74}
          />
        ) : (
          <h3 className="ellipsis blue-text">{headerName}</h3>
        )}

        {!isEditing && project.createdById === getUserId() && (
          <Button
            icon={PrimeIcons.PENCIL}
            className="edit-button"
            onClick={handleEditClick}
          />
        )}
        <VisibilityChip type={currentProject?.type} />
      </div>
      <ActionsProject project={project} projectId={projectId} />
    </div>
  ) : (
    <></>
  );
};
